<template>
  <div class="editor-container">
    <div class="header">
      <button class="back-btn" @click="goBack">
        <span>←</span> 返回
      </button>
      <h1>图片标注编辑器 - 测试版</h1>
    </div>
    
    <div class="content-wrapper" :style="'height:'+screenHeight+'px'">
      <div class="image-area">
        <!-- 提示信息 -->
        <div class="marker-controls">
          <div class="drawing-hint">
            在图片上拖动鼠标创建标记框
          </div>
        </div>
        
        <image-marker
          ref="imageMarker"
          :image-path="imageUrl"
          :scroll-top="scrollTop"
          :markers="markers"
          @update:markers="updateMarkers"
          @update:currentbox="updateCurrentBox"
          @update:currentindex="updateCurrentIndex"
          @edit-marker="editMarker"
          @delete-marker="deleteMarker"
          @marker-created="onMarkerCreated"
        />
      </div>
      
      <div class="control-area">
        <div class="submit-area">
          <button class="primary-btn" @click="showIdentifyDialog">开始识别</button>
          <button class="primary-btn" @click="saveData">保存并返回</button>
        </div>
        
        <div class="table-container">
          <data-table
            :columns="columns"
            :data="markers"
            :show-header="true"
            :stripe="true"
            :border="true"
            :show-edit-button="false"
            :show-delete-button="false"
            @cell-click="cellClick"
          />
        </div>
      </div>
    </div>
    
    <!-- 编辑弹窗 -->
    <modal-popup 
      :visible.sync="showEditModal"
      title="编辑标注"
      width="600"
    >
      <div class="popup-content">
        <div class="form-item">
          <label class="title">【部件】</label>
          <select v-model="tableMarkers.type" @change="bindPickerChange" class="form-select">
            <option v-for="(item, idx) in partTypes" :key="idx" :value="item">{{item}}</option>
          </select>
          <div class="button-group">
            <button @click="setHoldPageType" class="mini-btn">整页一样</button>
            <button @click="downSetHoldPageType" class="mini-btn">向下填充</button>
          </div>
        </div>
        
        <div class="form-item">
          <label class="title">【数量】</label>
          <input 
            v-model="tableMarkers.num" 
            @input="bindNumChange" 
            class="form-input" 
            type="number" 
            maxlength="3" 
            placeholder="1" 
          />
          <button @click="downSetHoldPageNum" class="mini-btn">向下填充</button>
        </div>
        
        <div class="form-item">
          <label class="title">【零件号】</label>
          <input 
            v-model="tableMarkers.content" 
            @input="bindPartChange" 
            class="form-input" 
            maxlength="10" 
            placeholder="先自动识别,出错再改" 
          />
        </div>
      </div>
    </modal-popup>
    
    <!-- 识别确认弹窗 -->
    <confirm-dialog 
      :visible.sync="showIdentifyModal"
      title="选择"
      content="是否从头开始识别"
      cancel-text="重新开始"
      confirm-text="继续(空白的列)"
      @confirm="continueIdentify"
      @cancel="blankIdentify"
    />
    
    <!-- 加载提示 -->
    <loading-overlay :visible="isLoading" :message="loadingMessage" />
  </div>
</template>

<script>
import ImageMarker from '@/components/ImageMarker.vue';
import DataTable from '@/components/DataTable.vue';
import ModalPopup from '@/components/ModalPopup.vue';
import ConfirmDialog from '@/components/ConfirmDialog.vue';
import LoadingOverlay from '@/components/LoadingOverlay.vue';

export default {
  components: {
    ImageMarker,
    DataTable,
    ModalPopup,
    ConfirmDialog,
    LoadingOverlay
  },
  name: 'EditorTest',
  data() {
    return {
      id: 1,
      scrollTop: 0,
      screenHeight: 0,
      screenWidth: 0,
      imageUrl: "https://picsum.photos/seed/test123/800/600.jpg",
      markers: [
        {
          height: 10, 
          width: 15, 
          x: 20, 
          y: 30,
          type: "头",
          num: 1,
          content: "A001",
          picsrc: "https://picsum.photos/seed/test123/800/600.jpg",
        },
        {
          height: 8, 
          width: 12, 
          x: 50, 
          y: 40,
          type: "身躯",
          num: 1,
          content: "B002",
          picsrc: "https://picsum.photos/seed/test123/800/600.jpg",
        }
      ],
      currentIndex: 0,
      currentBox: {
        height: 19.8,
        width: 18.8, 
        x: 21.6, 
        y: 39.4,
        type: "",
        num: 1,
        content: "",
        picsrc: "",
      },
      partTypes: ['', '头', '身躯', '腰', '肩甲', '手臂', '左臂', '右臂', '腿', '脚', '左腿', '右腿', '武器1', '武器2', '武器3', '背包1', '背包2', '盾牌', '其他配件', '头-骨架', '身躯-骨架', '腰-骨架', '手臂-骨架', '腿-骨架'],
      partTypeIndex: 0,
      columns: [
  { name: 'picsrc', label: '图片', type: "img", width: 100 },
  { name: 'type', label: '部件', width: 80, emptyString: '--' },
  { name: 'num', label: '数量', width: 100, align: 'right' },
  { name: 'content', label: '零件号', width: 150, emptyString: '' },
],
      tableIndex: 0,
      tableMarkers: [],
      showEditModal: false,
      showIdentifyModal: false,
      isLoading: false,
      loadingMessage: "加载中"
    }
  },
  mounted() {
    // 获取屏幕高度
    this.screenHeight = window.innerHeight - 100; // 减去头部高度
    this.screenWidth = window.innerWidth;
    
    // 监听滚动事件
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    // 移除滚动事件监听
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    // 返回上一页
    goBack() {
      this.$router.go(-1);
    },
    
    // 处理滚动事件
    handleScroll() {
      this.scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    },
    
    // 处理标记创建事件
    onMarkerCreated(marker) {
      // 选中新创建的标记并打开编辑弹窗
      const index = this.markers.length - 1;
      this.editMarker(marker, index);
    },
    
    // 保存数据
    saveData() {
      this.isLoading = true;
      this.loadingMessage = "保存中";
      
      // 模拟保存操作
      setTimeout(() => {
        this.isLoading = false;
        this.showMessage("保存成功", "success");
      }, 1000);
    },
    
    // 设置整页类型
    setHoldPageType() {
      if (this.partTypes[this.partTypeIndex] != "") {
        const partType = this.partTypes[this.partTypeIndex];
        this.markers.forEach((item, index) => {
          this.markers[index].type = partType;
        });
        this.showMessage("修改完成", "success");
      } else {
        this.showMessage("不能为空", "warning");
      }
    },
    
    // 选择器变化事件
    bindPickerChange(e) {
      this.partTypeIndex = e.target.value;
      this.markers[this.tableIndex].type = this.partTypes[this.partTypeIndex];
    },
    
    // 数量输入变化
    bindNumChange(e) {
      this.markers[this.tableIndex].num = e.target.value;
    },
    
    // 零件号输入变化
    bindPartChange(e) {
      this.markers[this.tableIndex].content = e.target.value;
    },
    
    // 编辑标记
    editMarker(item, index) {
      this.tableIndex = index;
      this.tableMarkers = {...item};
      this.showEditModal = true;
    },
    
    // 删除标记
    deleteMarker(item, index) {
      const indexToDelete = this.markers.findIndex(it => it.picsrc == item.picsrc);
      if (indexToDelete != -1) {
        this.markers.splice(indexToDelete, 1);
      }
    },
    
    // 表格单元格点击
    cellClick(item, index, column) {
      this.tableIndex = index;
      this.tableMarkers = {...item};
      this.showEditModal = true;
    },
    
    // 显示识别对话框
    showIdentifyDialog() {
      this.showIdentifyModal = true;
    },
    
    // 继续识别
    continueIdentify() {
      this.showIdentifyModal = false;
      this.showMessage("继续识别功能", "info");
    },
    
    // 从头开始识别
    blankIdentify() {
      this.showIdentifyModal = false;
      this.showMessage("从头识别功能", "info");
    },
    
    // 向下设置类型
    downSetHoldPageType() {
      if (this.partTypes[this.partTypeIndex] != "") {
        const partType = this.partTypes[this.partTypeIndex];
        this.markers.forEach((item, index) => {
          if (index > this.tableIndex) {
            this.markers[index].type = partType;
          }
        });
        this.showMessage("修改完成", "success");
      } else {
        this.showMessage("不能为空", "warning");
      }
    },
    
    // 向下设置数量
    downSetHoldPageNum() {
      if (this.tableMarkers.num != "") {
        const partNum = this.tableMarkers.num;
        this.markers.forEach((item, index) => {
          if (index > this.tableIndex) {
            this.markers[index].num = partNum;
          }
        });
        this.showMessage("修改完成", "success");
      } else {
        this.showMessage("不能为空", "warning");
      }
    },
    
    // 匹配markers，确保所有字段都存在
    matchMarkers() {
      const defaultValues = {
        height: 0,
        width: 0,
        x: 0,
        y: 0,
        type: "",
        num: 1,
        content: "",
        picsrc: ""
      };
      
      this.markers = this.markers.map(marker => {
        return {
          ...defaultValues,
          ...marker,
          content: marker.content || defaultValues.content
        };
      });
    },
    
    // 更新markers
    updateMarkers(markers) {
      this.markers = markers;
    },
    
    // 更新当前框
    updateCurrentBox(box) {
      this.currentBox = box;
    },
    
    // 更新当前索引
    updateCurrentIndex(index) {
      this.currentIndex = index;
    },
    
    // 显示消息提示
    showMessage(message, type = "info") {
      // 这里可以使用更复杂的提示组件，暂时使用简单的alert
      if (type === "error") {
        alert(`错误: ${message}`);
      } else if (type === "warning") {
        alert(`警告: ${message}`);
      } else {
        alert(message);
      }
    }
  }
}
</script>

<style scoped>
.editor-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
}

.header {
  display: flex;
  align-items: center;
  padding: 10px 20px;
  background-color: #f5f5f5;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  z-index: 100;
}

.back-btn {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 8px 16px;
  background-color: #909399;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin-right: 20px;
}

.back-btn:hover {
  background-color: #777a80;
}

.header h1 {
  margin: 0;
  font-size: 20px;
  color: #333;
}

.content-wrapper {
  display: flex;
  flex: 1;
  overflow: hidden;
}

.image-area {
  width: 60%;
  height: 100%;
  overflow: auto;
  border-right: 1px solid #eee;
  position: relative;
}

.marker-controls {
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 10;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.add-marker-btn {
  padding: 8px 16px;
  background-color: #67C23A;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
}

.add-marker-btn:hover {
  background-color: #85ce61;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.add-marker-btn.active {
  background-color: #E6A23C;
  animation: pulse 1.5s infinite;
}

.drawing-hint {
  padding: 8px 12px;
  background-color: rgba(230, 162, 60, 0.9);
  color: white;
  border-radius: 4px;
  font-size: 14px;
  animation: blink 1.5s infinite;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

@keyframes pulse {
  0% { transform: scale(1); }
  50% { transform: scale(1.05); }
  100% { transform: scale(1); }
}

@keyframes blink {
  0% { opacity: 1; }
  50% { opacity: 0.7; }
  100% { opacity: 1; }
}

.control-area {
  width: 40%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 20px;
  box-sizing: border-box;
  overflow: auto;
}

.submit-area {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-bottom: 20px;
}

.primary-btn {
  padding: 8px 16px;
  background-color: #409EFF;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.primary-btn:hover {
  background-color: #66b1ff;
}

.table-container {
  flex: 1;
  overflow: auto;
}

.popup-content {
  padding: 20px;
  background-color: #fff;
  border-radius: 5px;
  border: 1px solid #aaaaaa;
  max-width: 500px;
  margin: 0 auto;
}

.form-item {
  margin-bottom: 20px;
}

.title {
  display: block;
  font-size: 16px;
  margin-bottom: 8px;
  font-weight: bold;
}

.form-select, .form-input {
  width: 100%;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-sizing: border-box;
  margin-bottom: 10px;
}

.button-group {
  display: flex;
  gap: 10px;
}

.mini-btn {
  padding: 5px 10px;
  background-color: #f0f0f0;
  border: 1px solid #ddd;
  border-radius: 3px;
  cursor: pointer;
  font-size: 12px;
}

.mini-btn:hover {
  background-color: #e0e0e0;
}
</style>